import { createFileRoute } from "@tanstack/react-router";
import { CreateProjectSetupPage } from "@/features/projects/create-project/create-project.setup.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/projects/create")({
  component: CreateProjectSetupPage,
});
